import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AlreadyExistingIcon } from "../../../../assets/images/defaults/ConstructionMachineCraneLiftSvgrepo.svg";
import { ReactComponent as NewDeveloperIcon } from "../../../../assets/images/defaults/newDeveloper.svg";

export const VendorTypes = ({
  parentTranslationPath,
  translationPath,
  selectVendorType,
  setSelectVendorType,
  clearData,
}) => {
  const { t } = useTranslation(parentTranslationPath);

  return (
    <>
      <div className="w-100 d-flex-center">
        <div
          className={`vendor-type  ${
            selectVendorType === "new" ? "active" : ""
          }`}
        >
          <div
            className="d-flex-column-center"
            onClick={() => {
              setSelectVendorType("new");
              clearData();
            }}
          >
            <span>
              {" "}
              <NewDeveloperIcon />{" "}
            </span>
            <span>{t(`${translationPath}new-vendor`)}</span>
          </div>
        </div>
        <div
          className={`vendor-type  ${
            selectVendorType === "existing" ? "active" : ""
          }`}
          onClick={() => {
            setSelectVendorType("existing");
            clearData();
          }}
        >
          <span>
            {" "}
            <AlreadyExistingIcon />{" "}
          </span>
          <span>{t(`${translationPath}already-existing`)}</span>
        </div>
      </div>
    </>
  );
};
